import styled from "styled-components";

export const ContentModalSucess = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h1 {
    color: #2e353d;
    font-family: Montserrat;
    font-size: 2.4rem;
    font-weight: 800;
    line-height: 2.4rem;
    margin-top: 2.5rem;
  }
  p {
    color: rgba(8, 8, 43, 0.55);
    font-family: Montserrat;
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-align: center;
    width: 34rem;
  }
  .icon-check-success {
    height: 12rem;
    width: 21.3rem;
  }
`;

export const ContainerModalSucess = styled.div`
  ${(props) => `
      font-family: ${props.theme.fontFamilies.primaryFont};
  `}

  .close-modal-button {
    display: flex;
    justify-content: end;
    margin-top: 1.5rem;
  }
  .close-button {
    cursor: pointer;
    padding: 0.3rem;
  }
`;
